var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteMedical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 480L448 352H320V480ZM400 32H48C21.49 32 0 53.492 0 80V432C0 458.508 21.49 480 48 480H288V352C288 334.328 302.326 320 320 320H448V80C448 53.492 426.51 32 400 32ZM320 248C320 252.375 316.375 256 312 256H256V312C256 316.375 252.375 320 248 320H200C195.625 320 192 316.375 192 312V256H136C131.625 256 128 252.375 128 248V200C128 195.625 131.625 192 136 192H192V136C192 131.625 195.625 128 200 128H248C252.375 128 256 131.625 256 136V192H312C316.375 192 320 195.625 320 200V248Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteMedical);
export default __webpack_public_path__ + "static/media/note-medical.a6cf365bb092a989136f5b617a72541b.svg";
export { ForwardRef as ReactComponent };